<script>
import GroupData from "../data/groupData"

export default {
  name: 'user',
  data() {
    return {
      username: localStorage.getItem('name'),
      h: 0,
      // 表格数据
      loading: true,
      total: 0,
      tableData: [],
      client: [],
      currentPage: 1,
      pageSize: 10,
      options: [{value: -1, label: '不允许'}, {value: 0, label: '普通客户价'}, {
        value: 1,
        label: '一级批发价'
      }, {value: 2, label: '二级批发价'}, {value: 3, label: '三级批发价'}, {
        value: 4,
        label: '四级批发价'
      }, {value: 5, label: '五级批发价'}, {value: 6, label: '六级批发价'}, {
        value: 7,
        label: '七级批发价'
      }, {value: 8, label: '八级批发价'}, {value: 9, label: '九级批发价'}, {value: 10, label: '十级批发价'}],
      // 对话框数据
      dialogFormVisible: false,
      user: {
        name: "",
        phone: "",
        usergroup: "",
        companyName: "",
        address: "",
        look: "",
        viewMemo: "",
        scatteredPrice: "",
        wholePrice: "",
        placeOrder: "",
        ispromotional: "",
        client: ""
      },
      formLabelWidth: "70px",
      // 搜索数据
      searchName: "",
      searchPhone: "",
      groupValue: [],
      userGroupValue: "",
      group: GroupData(),
    }
  },
  created() {
    this.h = document.documentElement.clientHeight
    this.$axios.get("/admin/partner").then((res) => {
      var client = res.data.data
      client.unshift({id: "0", idsettlementPartner: "0", name: " "})
      this.client = client
    })
  },
  mounted() {
    if (localStorage.getItem('jurisdiction') != "管理员") {
      this.$router.push({name: 'no'})
    }
    this.getUser()
  },
  methods: {
    // 获取数据
    getUser() {
      this.loading = true
      this.$axios.get("/admin/user", {
        params: {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          name: this.searchName,
          phone: this.searchPhone,
        }
      }).then((res) => {
        this.tableData = res.data.data.records
        this.total = res.data.data.total
        this.loading = false
      })
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val
      this.getUser()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getUser()
    },
    // 打开对话框
    handleClick(e) {
      this.dialogFormVisible = true
      this.user.usergroup = e.usergroup
      this.userGroupValue = e.usergroup
      this.user.name = e.name
      this.user.phone = e.phone
      this.user.companyName = e.companyName
      this.user.address = e.address
      this.user.look = e.look
      this.user.viewMemo = e.viewMemo
      this.user.scatteredPrice = e.scatteredPrice
      this.user.wholePrice = e.wholePrice
      this.user.placeOrder = e.placeOrder
      this.user.ispromotional = e.ispromotional
      this.user.client = e.client
    },
    clearForm() {
      this.user.name = ""
      this.user.phone = ""
      this.user.usergroup = ""
      this.userGroupValue = ""
      this.user.companyName = ""
      this.user.address = ""
      this.user.look = ""
      this.user.viewMemo = ""
      this.user.scatteredPrice = ""
      this.user.wholePrice = ""
      this.user.placeOrder = ""
      this.user.ispromotional = ""
      this.user.client = ""
    },
    // 设置用户信息
    setUser() {
      if (this.$refs['myGroup1'].getCheckedNodes()[0] != null) {
        const arr = this.$refs['myGroup1'].getCheckedNodes()[0].pathLabels;
        let group = "";
        for (let i = 0; i < arr.length; i++) {
          group += arr[i] + "/"
        }
        this.user.usergroup = group.substring(0, group.length - 1);
      }
      this.$axios.post("/admin/user", this.user).then((res) => {
        this.$axios.post("/admin/log", {
          "type": "管理员",
          "module": "用户管理",
          "name": this.username,
          "content": "设置了'" + this.user.phone + "'的信息"
        })
        this.$message.success("修改成功")
        this.dialogFormVisible = false
        this.getUser()
      }).catch((e) => {
        this.$message.error("修改失败")
      })
    },
    close() {
      this.dialogFormVisible = false
      this.clearForm()
    },
    // 搜索
    search(){
      this.currentPage = 1
      this.getUser()
    },
    searchClear() {
      this.currentPage = 1
      this.searchPhone = ""
      this.searchName = ""
      this.groupValue = []
      this.getUser()
      document.getElementById("page").style.visibility = "visible";
    },
    searchGroup() {
      const length = this.$refs['myGroup'].getCheckedNodes().length
      let allData = []
      const taData = []
      this.$axios.get("/admin/user/all").then((res) => {
        allData = res.data.data
        for (let i = 0; i < length; i++) {
          const arr = this.$refs['myGroup'].getCheckedNodes()[i].pathLabels;
          let group = "";
          for (let i = 0; i < arr.length; i++) {
            group += arr[i] + "/"
          }
          group = group.substring(0, group.length - 1);
          allData.filter((i) => {
            if (group === i.usergroup) {
              taData.push(i);
            }
          });
        }
        this.tableData = taData
        document.getElementById("page").style.visibility = "hidden";//隐藏
      })
    },
    out() {
      this.$router.push({name: 'login'})
    },
    clearBond() {
      this.$confirm('此操作将重置' + this.user.phone + '的微信绑定, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.put("/admin/user/clearBond/" + this.user.phone).then((res) => {
          this.$axios.post("/admin/log", {
            "type": "管理员",
            "module": "用户管理",
            "name": this.username,
            "content": "重置了'" + this.user.phone + "'的微信绑定"
          })
          this.$message.success("修改成功")
        }).catch((e) => {
          this.$message.error("修改失败")
        })
      }).catch(() => {
        this.$message.info('已取消操作');
      })
    },
    clearModel() {
      this.$confirm('此操作将重置' + this.user.phone + '的登录设备, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.put("/admin/user/clearModel/" + this.user.phone).then((res) => {
          this.$axios.post("/admin/log", {
            "type": "管理员",
            "module": "用户管理",
            "name": this.username,
            "content": "重置了'" + this.user.phone + "'的登录设备"
          })
          this.$message.success("修改成功")
        }).catch((e) => {
          this.$message.error("修改失败")
        })
      }).catch(() => {
        this.$message.info('已取消操作');
      });
    }
  }
}
</script>
<template>
  <div style="height: 100%">

    <el-header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>用户管理</el-breadcrumb-item>
        <div style="position: absolute; right: 100px;top: 20px;font-size: 15px">
          <div style="display:flex;align-items:center;">
            <el-avatar size="large" style="margin: 5px;"
                       src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"></el-avatar>
            {{ username }}
            <el-button type="text" @click="out" style="margin: 5px;">退出登录</el-button>
          </div>
        </div>
      </el-breadcrumb>
      <el-input class="topInput" placeholder="请输入要搜索的姓名" prefix-icon="el-icon-search" v-model="searchName"
                clearable @keyup.enter.native="search"></el-input>
      <el-input class="topInput" placeholder="请输入要搜索的手机号" prefix-icon="el-icon-search" v-model="searchPhone"
                clearable @keyup.enter.native="search"></el-input>
      <el-button type="primary" plain icon="el-icon-search" @click="search">搜索</el-button>
      <el-cascader
        ref="myGroup"
        v-model="groupValue"
        placeholder="请选择要查询的用户分组"
        :options="group"
        clearable
        collapse-tags
        row-key="id"
        :props="{ expandTrigger: 'hover', multiple: true }"
        @change="searchGroup"></el-cascader>
      <el-button type="danger" plain icon="el-icon-delete" @click="searchClear">重置</el-button>
    </el-header>

    <el-main class="el-main">
      <el-table
        v-loading="loading"
        :data="tableData"
        stripe
        border
        :height="h!=0?h-200:500"
        highlight-current-row
        current-row-key="id"
        :max-height="h!=0?h-200:500"
      >
        <el-table-column label="序号" width="50" align="center">
          <template slot-scope="scope">
            {{ (scope.$index + 1) + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="姓名" align="center" width="70"></el-table-column>
        <el-table-column prop="phone" label="手机号" align="center" width="115"></el-table-column>
        <el-tooltip class="item" effect="light" content="管理员可以看到进价" placement="top-start">
          <el-table-column prop="usergroup" label="用户分组" align="center" width="115"></el-table-column>
        </el-tooltip>
        <el-table-column show-overflow-tooltip prop="client" label="客户姓名" width="150">
          <template slot-scope="scope">
            {{
              client.find(key => key.id == scope.row.client) == null ? "" : client.find(key => key.id == scope.row.client).name
            }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="companyName" label="公司名称" width="150"></el-table-column>
        <el-table-column show-overflow-tooltip prop="address" label="地址" width="200"></el-table-column>
        <el-table-column label="观看权限" align="center" width="79">
          <template slot-scope="scope">
            <el-tag :type="scope.row.look === 0 ? 'primary' : 'danger'" effect="dark" size="medium">
              {{ scope.row.look === 0 ? '允许' : '不允许' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="viewMemo" label="查看备忘录" align="center" width="90">
          <template slot-scope="scope">
            <el-tag :type="scope.row.viewMemo === 0 ? 'primary' : 'danger'" effect="dark" size="medium">
              {{ scope.row.viewMemo === 0 ? '允许' : '不允许' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="scatteredPrice" label="散价" width="91" align="center">
          <template slot-scope="scope">
            {{ options.find(key => key.value === scope.row.scatteredPrice).label }}
          </template>
        </el-table-column>
        <el-table-column prop="wholePrice" label="整件价格" width="91" align="center">
          <template slot-scope="scope">
            {{ options.find(key => key.value === scope.row.wholePrice).label }}
          </template>
        </el-table-column>
        <el-table-column prop="placeOrder" label="下单权限" width="79" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.placeOrder === 0 ? 'primary' : 'danger'" effect="dark" size="medium">
              {{ scope.row.placeOrder === 0 ? '允许' : '不允许' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="ispromotional" label="促销观看权限" width="90" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.ispromotional === 0 ? 'primary' : 'danger'" effect="dark" size="medium">
              {{ scope.row.ispromotional === 0 ? '允许' : '不允许' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="gmtCreate" label="注册时间" width="99" align="center">
        </el-table-column>
        <el-table-column fixed="right" label="操作" align="center" width="70">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="medium">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>

    <el-footer class="el-footer" id="page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :pager-count="11"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-footer>

    <el-dialog title="编辑用户" :visible.sync="dialogFormVisible" @close="close">
      <el-form :model="user" :inline="true">
        <el-button type="danger" @click="clearBond">重置微信绑定</el-button>
        <el-button type="danger" @click="clearModel">重置登录设备</el-button>
        <br>
        <el-form-item label="姓名" :label-width="formLabelWidth">
          <el-input v-model="user.name" style="width: 80px;"></el-input>
        </el-form-item>
        <el-form-item label="手机号" label-width="55px">
          <el-input v-model="user.phone" :disabled="true" style="width: 125px;" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="公司名称" :label-width="formLabelWidth">
          <el-input v-model="user.companyName" style="width: 230px;"
                    autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="地址" :label-width="formLabelWidth">
          <el-input v-model="user.address" style="width: 500px;" autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="用户分组" label-width="70px">
          <el-tooltip class="item" effect="dark" content="管理员可以看到进价" placement="top-start">
            <el-cascader
              style="width: 300px;"
              ref="myGroup1"
              v-model="user.usergroup"
              :placeholder="userGroupValue"
              :options="group"
              :props="{ expandTrigger: 'hover' }"></el-cascader>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="客户姓名" :label-width="formLabelWidth">
          <el-select v-model="user.client" filterable placeholder="请选择">
            <el-option
              v-for="item in client"
              :key="item.id"
              :label="item.name"
              :value="Number(item.id)">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="观看权限" :label-width="formLabelWidth">
          <el-select v-model="user.look" placeholder="请选择">
            <el-option label="允许" :value=0></el-option>
            <el-option label="不允许" :value=-1></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="查看备忘录" :label-width="formLabelWidth">
          <el-select v-model="user.viewMemo" placeholder="请选择">
            <el-option label="允许" :value="0"></el-option>
            <el-option label="不允许" :value="-1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="下单权限" :label-width="formLabelWidth">
          <el-select v-model="user.placeOrder" placeholder="请选择">
            <el-option label="允许" :value='0'></el-option>
            <el-option label="不允许" :value='-1'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="促销观看权限" :label-width="formLabelWidth">
          <el-select v-model="user.ispromotional" placeholder="请选择">
            <el-option label="允许" :value='0'></el-option>
            <el-option label="不允许" :value='-1'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="散价" :label-width="formLabelWidth">
          <el-select v-model="user.scatteredPrice" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="整件价格" :label-width="formLabelWidth">
          <el-select v-model="user.wholePrice" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="setUser()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<style scoped>
.el-header {
  margin-top: 30px;
  margin-left: 25px;
}

.topInput {
  margin-top: 15px;
  width: 200px;
  margin-bottom: 30px;
}

.el-form .el-form-item {
  margin: 10px;
}

.el-main {
  margin-left: 25px;
}

.el-footer {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/userView.vue